import React from 'react';
import ReactDOM from 'react-dom/client';
import { ThemeProvider } from '@mui/material/styles';
import App from './App';
import globalTheme from 'themes/globalTheme';
import { PublicClientApplication } from "@azure/msal-browser"; 
import { MsalProvider } from "@azure/msal-react";
import { msalConfig } from "config/authConfigB2C";
import {ConfirmContextProvider} from "store/ConfirmContextProvider";
import {SnackbarContextProvider} from "store/SnackbarContextProvider";

import ConfirmDialog from 'components/library/alerts/ConfirmDialog';
import GlobalSnackbar from 'components/library/alerts/GlobalSnackbar'; 

const msalInstance = new PublicClientApplication(msalConfig);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <MsalProvider instance={msalInstance}>
      <ThemeProvider theme={globalTheme}>
        <SnackbarContextProvider>
          <ConfirmContextProvider>
            <App />
            <ConfirmDialog />
            <GlobalSnackbar />
          </ConfirmContextProvider>
        </SnackbarContextProvider>
      </ThemeProvider>
    </MsalProvider>  
  </React.StrictMode>
);
